import React, { useState } from "react";
import Dialog from "../dialog";

type Props = {
    title: React.ReactNode;
    image: string,
    imageAlt: string,
    list: any,
    category: string
};

const SolutionFeatureSection: React.FC<Props> = ({ title, image, imageAlt, list, category }) => {
    const [imageOpen, setImageOpen] = useState(false);

    return (<>
        <div className={"d-flex"}>
            <div className={"left-block"}>
                {category.length > 0 ? <div className={"category"}>{category}</div> : ''}
                <h3>{title}</h3>
                <ul>
                    {list.map((item: string, index: number) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>
            </div>
            <div className={"right-block"}>
                <img src={image} alt={imageAlt}
                    width={"200"} height={"200"}
                    onClick={() => setImageOpen(true)} />
                <span> Click Image to Zoom </span>
            </div>
        </div>
        <Dialog
            isOpen={imageOpen}
            position={"center"}
            onClose={() => {
                setImageOpen(false);
            }}
            size={"md"}
            verticalCenter={true}
        >
            <div>
                <img src={image} alt={imageAlt} width={100} height={100} />
            </div>
        </Dialog>

    </>

    )
}

export default SolutionFeatureSection;